export default __webpack_public_path__ + "static/media/alignment-v-center.d6c6420a.svg";